import colors from 'library/assets/vars/colors.json'

# Look up a color name (ie. 'light-green') from a hex string
export getColorNameFromHex = (colorHex) ->
	if colorHex is '#ffffff' or colorHex is '#FFFFFF'
		return 'white'
	colorName = Object.keys(colors).find (key) -> colors[key] is colorHex
	return colorName or 'transparent'
